import React, { useEffect } from "react";
import { CheckCircle, XCircle } from "lucide-react";

const Toast = ({ message, subText, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 6000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast-notification ${type}`}>
      <div className="toast-content">
        {type === "success" ? <CheckCircle size={20} /> : <XCircle size={20} />}
        <div className="toast-text">
          <p className="toast-message">{message}</p>
          {subText && <p className="toast-subtext">{subText}</p>}
        </div>
      </div>
    </div>
  );
};

export default Toast;
